import { CommitteeManagementPageContent } from "./_components/CommitteeManagementPageContent";

export default function AllCommitteesPage() {
  return <CommitteeManagementPageContent activeTab="all" />;
}
